// A KPI card holds one short label and one number, so it stops reading as a card
// once it is much wider than its text. Add columns as the viewport grows instead
// of letting four cards stretch across it.
//
// Both places this grid actually renders (`WidgetsDashboard`'s Portfolio
// overview card, `PortfolioDashboard`'s fallback) nest it in a ~16/24-width
// column beside a sibling card, never the full page — so the breakpoint tiers
// size against that ~65% container, not the viewport. `xxl: 4` (6 tiles/row)
// was tuned for a full-width container and truncated every label once wide
// monitors pushed the grid past `xxl` while the sibling card kept its third —
// `xxl: 6` keeps the same 4-tiles/row density `xl` already uses.
export const KPI_CARD_COL = { xs: 12, lg: 8, xl: 6, xxl: 6 } as const

// The Home dashboard's Portfolio overview runs the full page width, so it sizes
// against the viewport rather than a ~65% column: four tiles a row from `lg`
// (the guidelines' desktop maximum), three on a tablet, two on a phone.
export const KPI_CARD_COL_WIDE = {
  xs: 12,
  md: 8,
  lg: 6,
  xl: 6,
  xxl: 6
} as const
